module.exports = __webpack_public_path__ + "saira-bold-webfont.9d7aa9a48ef74b61f1c8.woff";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/saira-bold-webfont.woff
// module id = ../../../../../src/assets/fonts/saira-bold-webfont.woff
// module chunks = styles